export default "__VITE_ASSET__Du95qKRC__"